import Vue from 'vue'

const filters = {
  euro: function(value) {
    var nf = new Intl.NumberFormat(['de-DE'], {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0, 
      minimumFractionDigits: 0, 
      //maximumSignificantDigits: 5
    })
    return nf.format(value)
  },
  mileage: function(value) {
    var nf = new Intl.NumberFormat(['de-DE'])
    return nf.format(value) + ' km'
  },
  power: function(value) {
    var psValue = Math.round(1.35962 * value)
    return value + 'kW / ' + psValue + ' (PS)'
  },
  number(value) {
    const nf = new Intl.NumberFormat(['de-DE'])
    return nf.format(value)
  },
  availableLabel: function(carnumber, vorlauf) {
    if (carnumber != undefined) {
      if (carnumber.includes('BSTL')) {
        return 'BSTL'
      } else if (vorlauf == 'Y') {
        return 'VORLAUF'
      } else if (carnumber.length == 17) {
        return 'LAGER'
      } else {
        return 'VORLAUF'
      }
    }
  },
  firstregdate: function(value) {
    if (value == 'EU-Frzg.') {
      return '-'
    } else {
      return value
    }
  },
  matchFeatureKey(key) {
    let label = ''
    if (key === 'extras') {
      label = 'Extras'
    }
    if (key === 'comfort') {
      label = 'Komfort'
    }
    if (key === 'exterior') {
      label = 'Aussenausstattung'
    }
    if (key === 'enviroment') {
      label = 'Sicherheit'
    }

    return label
  }
}

Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter])
})
